// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCardStatus\ApiCoordinationCardStatus.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// CoordinationCardStatusData is the class that CoordinationCardStatus serializes to/from
export interface CoordinationCardStatusData {
    Id : number;
	
	
    DefaultLabel : string;
    Definition : string;
    DisplayOrder : number;
}

// CoordinationCardStatusOptions is the class which may be passed to the CoordinationCardStatus constructor to define optional initial data values
export interface CoordinationCardStatusOptions {
    Id : number;
	
	
    DefaultLabel? : string;
    Definition? : string;
    DisplayOrder? : number;
}

export class CoordinationCardStatus {
    public Id : DataSignal<number>;
	
	
    public DefaultLabel : DataSignal<string>;
    public Definition : DataSignal<string>;
    public DisplayOrder : DataSignal<number>;

    constructor();
    constructor(data : CoordinationCardStatusOptions);
    constructor(data: CoordinationCardStatusOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.DefaultLabel = jsonableObservable(S.value<string>(data && data.DefaultLabel !== undefined ? data.DefaultLabel : ''));
        this.Definition = jsonableObservable(S.value<string>(data && data.Definition !== undefined ? data.Definition : ''));
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
    }

    static key(obj : CoordinationCardStatus) {
        return obj.Id();
    }
    
    static dataKey(obj : CoordinationCardStatusOptions) {
        return obj.Id;
    }

    static update(obj : CoordinationCardStatus, data : CoordinationCardStatusOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.DefaultLabel !== undefined) obj.DefaultLabel(data.DefaultLabel);
            if (data.Definition !== undefined) obj.Definition(data.Definition);
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCardStatus.ts